import React, { useState } from "react";
import { registerMyDevice } from "../../utils/Misc";
import { getOrCreateDeviceId } from "../../utils/DeviceId";

// Shared "register the device I'm on right now" form - used both inline
// (nowhere currently) and inside the blocking SpocDeviceRegistrationGate
// modal. Kept separate from that gate so the form itself doesn't know or
// care whether it's rendered inside a blocking overlay.
const RegisterDeviceForm = ({ branches, onRegistered }) => {
  const [branchId, setBranchId] = useState(branches.length === 1 ? String(branches[0].id) : "");
  const [label, setLabel] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (!branchId) {
      setMessage({ type: "danger", text: "Please select a facility." });
      return;
    }

    setSubmitting(true);
    try {
      await registerMyDevice({
        device_id: getOrCreateDeviceId(),
        branch_id: branchId,
        label: label.trim(),
      });
      setMessage({ type: "success", text: "Device registered." });
      onRegistered?.();
    } catch (err) {
      setMessage({
        type: "danger",
        text: err?.response?.data?.message || "Failed to register device.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {message && (
        <div className={`alert alert-${message.type} py-2`} role="alert">
          {message.text}
        </div>
      )}
      {branches.length > 1 && (
        <div className="mb-2">
          <label className="form-label">Facility</label>
          <select
            className="form-select form-select-sm"
            value={branchId}
            onChange={(e) => setBranchId(e.target.value)}
          >
            <option value="">Select facility</option>
            {branches.map((branch) => (
              <option key={branch.id} value={branch.id}>
                {branch.branch_name}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="mb-2">
        <label className="form-label">Device Name (optional)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="e.g. Front Desk Tablet"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
      </div>
      <button type="submit" className="btn btn-primary btn-sm w-100" disabled={submitting}>
        {submitting ? "Registering..." : "Register Device"}
      </button>
    </form>
  );
};

export default RegisterDeviceForm;
